import type { ApolloQueryResult } from '@apollo/client/core';
import Service, { service } from '@ember/service';
import purchaserQuery from 'dashboard/gql/queries/purchaser.gql';
import type { School } from 'dashboard/types';
import type ApolloService from 'ember-apollo-client/services/apollo';

export default class PawyallService extends Service {
  @service declare apollo: ApolloService;

  /**
   * Ensure that the school has an active subscription.
   *
   * This request confirms the current purchaser has an active subscription.
   * If the request fails with a specific error code, the paywall will be shown
   * (via Apollo GraphQL `onError`).
   *
   * @see /app/services/-apollo.ts
   */
  async ensureActiveSubscription(schoolId: string): Promise<void> {
    (await this.apollo.query({
      query: purchaserQuery,
      variables: {
        id: schoolId,
      },
    })) as ApolloQueryResult<School>;
  }
}
